<template>
  <div class="border-t border-gray-100 px-2 py-6 last:border-b">
    <div
      class="flex cursor-pointer items-center justify-between"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <component :is="titleTag" class="text-base font-bold">
        {{ title }}
      </component>
      <IconAngleUp
        class="transition-all duration-300"
        :class="{ 'rotate-180': isOpen }"
      />
    </div>
    <Bard
      v-if="isOpen"
      class="pr-10 pt-2 text-sm"
      :aria-hidden="!isOpen"
      :content="content"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string
    content: string
    open?: boolean
    titleTag?: string
  }>(),
  {
    titleTag: 'h3',
    open: false,
  }
)

const isOpen = ref(props.open)

const toggle = () => {
  isOpen.value = !isOpen.value
}
</script>
